import axios from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();
export const getCourseApi = async (
    url:string
) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.get(
            `${url}/course/GetAllCourse`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getCourseByPaginationApi = async (
    url:string,
    page: number,
    itemsPerPage: number,
    searchTerm : string
) => {
    const token = cookies.get('authToken');
    const params = new URLSearchParams();
    params.append("pageNumber", page.toString());
    params.append("pageSize", itemsPerPage.toString());
    params.append("searchTerm", searchTerm.toString());
    try {
        const response = await axios.get(
            `${url}/course/GetByPagination?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteCourseApi = async (id :string, url:string) =>{
    const token = cookies.get('authToken');

    try {
        const response = await axios.request({
            method: "DELETE",
            url: `${url}/Course/Delete`,
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            data: {
              id,
            },
          });
          return response.data;

      } catch (error) {
        throw error;
      }
}


export const addCourseApi = async (
    name: string,
    gender : number | null,
    url:string,
) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.post(
            `${url}/course/create`, {
            name,
            gender
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
        )
        return response.data;
    } catch (error) {
        throw error
    }
}

export const updateCourseApi = async (
    Id: string,
    Name: string,
    gender : number | null,
    url: string,
) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.post(
            `${url}/course/update`, {
                Id,
                Name,
                gender
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
        )
        return response.data;
    } catch (error) {
        throw error
    }
}
